module.exports = __webpack_public_path__ + "img/黄色背景图3.f0c4744a.jpg";